__turbopack_context__.v({
  "actions": "Create-module-scss-module__XcmhyG__actions",
  "alertBox": "Create-module-scss-module__XcmhyG__alertBox",
  "field": "Create-module-scss-module__XcmhyG__field",
  "fields": "Create-module-scss-module__XcmhyG__fields",
  "form": "Create-module-scss-module__XcmhyG__form",
  "formError": "Create-module-scss-module__XcmhyG__formError",
  "header": "Create-module-scss-module__XcmhyG__header",
  "title": "Create-module-scss-module__XcmhyG__title",
});
